import Vue from 'vue'
import Router from 'vue-router'
import PortalRoutes from '@/router/portal'
import SecurityRoutes from '@/router/security'
import ResearcherRoutes from '@/router/researcher'
import AdminRoutes from '@/router/admin'
import ParksRoutes from '@/router/parks'
import PartnersRoutes from '@/router/partners'
import CompaniesRoutes from '@/router/companies'
import CmsRoutes from '@/router/cms'
import NewsRoutes from '@/router/news'
import QuizPeriodRoutes from '@/router/quiz_period'
import ReportRoutes from '@/router/reports'
import MailingRoutes from '@/router/mailing'
import ExportRoutes from '@/router/export'
import ErrorsRoutes from '@/router/errors'
import authentication from '@/services/authentication'

Vue.use(Router)

const routes = [
  ...SecurityRoutes,
  ...ResearcherRoutes,
  ...AdminRoutes,
  ...PortalRoutes,
  ...ParksRoutes,
  ...PartnersRoutes,
  ...CompaniesRoutes,
  ...CmsRoutes,
  ...NewsRoutes,
  ...ErrorsRoutes,
  ...QuizPeriodRoutes,
  ...ReportRoutes,
  ...MailingRoutes,
  ...ExportRoutes
]

var router = new Router({
  routes,
  history: true,
  mode: 'history',
  saveScrollPosition: true,
  linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
  router.app.$Progress.start()

  if (!routeExists(to)) {
    redirectToNotFoundPage()
    return
  }

  if (!routeRequiresAuthentication(to)) {
    if (to.meta.preLoad) {
      to.meta.preLoad(to, authentication, router)
      .then(next())
      return
    }

    next()
    return
  }

  if (!authentication.isAuthenticated()) {
    redirectToLoginPage(to, next)
    return
  }

  if (!authentication.userHasAdminRole() &&
    !authentication.userHasResearcherRole() &&
    !userHasRequiredRole(to)) {
    redirectToUnauthorizedPage()
  }

  if (to.meta.preLoad) {
    to.meta.preLoad(to, authentication, router)
    .then(next())
    return
  }

  next()
  return
})

let routeExists = function (to) {
  return to.matched.length > 0
}

let redirectToNotFoundPage = function () {
  router.push({name: 'NotFoundError'})
}

let routeRequiresAuthentication = function (to) {
  return to.matched.some(record => record.meta.requiresAuthentication)
}

let redirectToLoginPage = function (to, next) {
  next({
    path: '/login',
    query: { redirect: to.fullPath }
  })
}

let userHasRequiredRole = function (to) {
  return to.matched.some(record => {
    return typeof record.meta.roleRequired === 'undefined' ||
    record.meta.roleRequired === null ||
    record.meta.roleRequired.includes(authentication.getUserRole())
  })
}

let redirectToUnauthorizedPage = function () {
  router.push({name: 'UnauthorizedError'})
}

router.afterEach((to, from) => {
  router.app.$Progress.finish()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js